import { HttpClient, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-upload-attachment-files',
  templateUrl: './upload-attachment-files.component.html',
})
export class UploadAttachmentFilesComponent implements OnInit {
  public progress: number;
  public message: string;
  @Output() public onUploadFinished = new EventEmitter();
  constructor(private http: HttpClient) { }
  ngOnInit() {
  }

  public uploadFile(files: any): void {
    if (files.length === 0) {
      return;
    }

    const fileToUpload: File = files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    this.http.post(`${environment.apiUrl}/Upload`, formData, { 
      reportProgress: true, 
      observe: 'events' 
    }).subscribe({
      next: (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          if (event.total) {
            this.progress = Math.round(100 * event.loaded / event.total);
          }
        } else if (event.type === HttpEventType.Response) {
          this.message = 'Upload success.';
          this.onUploadFinished.emit(event.body);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.message = 'Upload failed.';
        console.error(error);
      },
      complete: () => {
        console.log('Upload process completed.');
      }
    });
  }
}